{
  "slug": "how-is-iq-measured",
  "title": "智商是如何测量的?",
  "description": "了解标准化的智商测试、基于年龄的规范、子测试、百分比,以及为什么每个结果都有误差。",
  "summary": "智商是通过标准化的认知任务来测量的,原始表现与基于年龄的标准进行比较,并转换成一个分数,通常以 为中心。 100.",
  "sections": [
    {
      "heading": "从任务到标准化分数",
      "paragraphs": [
        "一个评估包含多个子测试,一个人可能会识别模式,操纵记忆中的信息,解决语言问题,或在时间限制下准确地工作。 原始总和本身没有什么意义,因此出版商将其与大量参考样本进行比较。",
        "表现与同年龄段的人进行比较,然后将分级分数合并为更广泛的指数分数和总体估计。"
      ]
    },
    {
      "heading": "规范、百分比和差值",
      "paragraphs": [
        "当前许多测试使用的均值为 100 标准偏差为 的 15百分位数表示位置: 100 是靠近 50百分位数,而 120 是周围的 91正态分布下的第 1 百分位数。",
        "不同的仪器使用不同的任务和规范,因此两个有效的测试并不总是产生相同的分数。"
      ]
    },
    {
      "heading": "为什么口译很重要",
      "paragraphs": [
        "经过训练的考官还会考虑子测试模式、语言、文化背景、测试条件以及评估的目的,并且会根据这些因素来确定每个分数的准确性。",
        "良好的测量取决于标准指令、合适的规范、测试安全性、可靠性和有效性,没有这些内容的数字可能会产生误导。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "为什么有些智商测试任务是有时间限制的?",
      "answer": "一些子测试测量处理效率,但许多推理任务没有时间限制或有宽泛的限制,时间仅仅是评估的一部分。"
    },
    {
      "question": "不同的智商测试能否给出不同的结果?",
      "answer": "是的,内容、规范、测量误差、健康和测试条件可能会造成合理的差异。"
    }
  ],
  "related": ["what-is-iq", "what-is-the-average-iq", "iq-score-ranges-explained"]
}
